import { ButtonVariant, CoButton } from "components/CoButton";
import useLabels from "hooks/useLabels";
import { RigorousJournalIcon } from "design_system";

const SCISCORE_URL = "https://www.sciscore.com/rti/overview.php";

interface PoweredBySciScoreProps {
  size?: "medium" | "small";
}

export const PoweredBySciScore = () => {
  const [componentLabels] = useLabels("tooltips.rigorous-journal");

  return (
    <div className="flex gap-2  items-center tiny-normal text-fg-muted whitespace-nowrap">
      {componentLabels["powered-by"]}
      <img
        alt="SciScore"
        className={`h-[14px]`}
        src="/images/sciscore-logo.webp"
      />
    </div>
  );
};

/**
 * @component RigorousJournalTooltip
 * @description Tooltip for score
 * @example
 * return (
 *   <RigorousJournalTooltip value={20} />
 * )
 */

interface RigorousJournalTooltipProps {
  value: number;
  title: string;
}

const RigorousJournalTooltip = ({
  value,
  title,
}: RigorousJournalTooltipProps) => {
  const [generalLabels, componentLabels] = useLabels(
    "general",
    "tooltips.rigorous-journal"
  );

  const handleClick = (e: any) => {
    e.preventDefault();
    window.open(SCISCORE_URL);
  };

  return (
    <div className="flex flex-col gap-3">
      <h2 className="flex items-center gap-3 sm-bold text-fg-base">
        <RigorousJournalIcon size="lg" />
        {title}
      </h2>
      <p
        dangerouslySetInnerHTML={{
          __html: componentLabels["title"].replace("{value}", value),
        }}
        className="sm-normal text-fg-base"
      />
      <p
        dangerouslySetInnerHTML={{
          __html: componentLabels["content"],
        }}
        className="tiny-normal text-fg-muted"
      />
      <CoButton
        variant={ButtonVariant.Tertiary}
        onClick={handleClick}
        iconRight="icon-external-link"
        label="Learn more"
        size="sm"
        href={SCISCORE_URL}
      />
      <div className="w-full pt-3 border-t border-t-border-base">
        <PoweredBySciScore />
      </div>
    </div>
  );
};

export default RigorousJournalTooltip;
